import { ANALYTICS_EVENT_SOURCE } from "./analytics";

export enum LoginResponseType {
  USER = "USER",
  TENANT = "TENANT",
  OWNER = "OWNER",
  PROSPECT = "PROSPECT",
  API = "API",
  VENDOR = "VENDOR"
}

export interface LoginResponseDto {
  type: LoginResponseType;
  id: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  loginEmail?: string;
  createdAt: Date;
  currentDbTenant: {
    id: string;
    companyName: string;
    language?: string;
    isHOAUser?: boolean;
    customerId?: string;
    createdAt?: Date;
    subscriptionPlan?: {
      price_quantity?: number;
      price_id?: string;
      trialEndsAt?: Date;
      numOfActiveUnits?: number;
    };
  };
}

export interface BaseSuperProperties {
  env: string;
  type: LoginResponseType;
  dbTenant: string;
  event_source: typeof ANALYTICS_EVENT_SOURCE;
  isHOAUser: boolean;
  numOfUnits: number;
  numOfActiveUnits: number;
  planType: SubscriptionPlanDisplayName;
  region: string;
  isTestUser: boolean;
}

export interface ClientSuperProperties extends BaseSuperProperties {
  userAgent: string;
  platform: DevicePlatform;
  platformType: DevicePlatformType;
}

export type DevicePlatform = "ios" | "android" | "web";

export type DevicePlatformType =
  | "iOS_native"
  | "iOS_web"
  | "iOS_native_tablet"
  | "iOS_web_tablet"
  | "android_native"
  | "android_web"
  | "android_native_tablet"
  | "android_web_tablet"
  | "desktop";

export type SubscriptionPlanDisplayName = "Starter" | "Pro" | "Premium";

export const getPlanNameByPriceId = (priceId: string): string => {
  // This is a simplified version - you may want to add more price ID mappings
  const priceIdMap: Record<string, string> = {
    price_basic: "Basic",
    price_pro: "Pro",
    price_enterprise: "Enterprise"
  };
  return priceIdMap[priceId] || "Unknown";
};
